/**
 * Whether a team is unlisted, for the screens that explain it.
 *
 * The HIDING itself is `visibleStartTeams` in `divisionTeamIndex` — one filter,
 * applied to the list the start step renders. This is the other half: two
 * screens past the picker need to know that the team a reader already holds is
 * unlisted, so they can say why it cannot be changed and withhold the share
 * link a private team must not hand out.
 */

import { findDivisionTeamById } from './divisionTeamIndex'

/**
 * Whether the team an id names is unlisted, according to the registration.
 *
 * Read from the registration list rather than from a held team object, because
 * a held team is not always the registration's shape: the register step can be
 * holding one restored as a bare `{ uid, id, name }`, without the flag, which
 * would otherwise read as public.
 */
export const isRegistrationTeamPrivate = (
  teams: Parameters<typeof findDivisionTeamById>[0],
  teamId: string | null | undefined
): boolean => findDivisionTeamById(teams, teamId)?.team.is_private === true
